import React from 'react';

export type LoginStep = 'credentials' | 'channel' | 'otp';

interface LoginCardProps {
  step: LoginStep;
  children: React.ReactNode;
}

const LoginCard: React.FC<LoginCardProps> = ({ step, children }) => (
  <div key={step} className="w-full">
    {children}
  </div>
);

export default LoginCard;
